module.exports = __webpack_public_path__ + "static/media/boy-child.f96e3f10.jpg";